<template>
  <div class="form">
    <div v-show="!loading">
      <h1>{{ $lang("2020障礙競技挑戰賽") }}</h1>
      <b-form-group class="py-3 px-3 text-light bg-info">
        <b-row v-if="is_group == 'entertainment'">
          <span class="text-light">{{ $lang("同樂組個人賽") }}</span>
        </b-row>
        <!-- <b-row v-if="is_group == 'team'">
        <span class="text-light">{{ $lang("TEXT_TEAM_APPLY") }}</span>
      </b-row> -->
        <b-row v-else>
          <b-form-radio-group v-model="isType" @change="selectedChange">
            <b-form-radio value="individual" :disabled="is_perview">
              <span class="text-light">{{ $lang("挑戰組個人賽") }}</span>
            </b-form-radio>
            <b-form-radio value="team" :disabled="is_perview || is_full">
              <span class="text-light radio_color">{{
                $lang("挑戰組隊際賽")
              }}</span>
            </b-form-radio>
          </b-form-radio-group>
        </b-row>
      </b-form-group>
      <b-form ref="form1" @submit="onSubmit" v-show="is_group === 'team'">
        <div class="form-header">
          <div class="checkbox-group">
            <p class="checkbox-attention-text">
              <span>{{ $lang("TEXT_ATTENTION_CHECKBOX") }}</span>
            </p>
            <b-form-checkbox v-model="form.isAgree3" :disabled="is_perview">
              <span style="padding-top: 2px" class="lbl">{{
                $lang(
                  "我已知悉於比賽當天必須完成接種兩劑新冠疫苗滿14天或持有效的核酸檢測陰性報告"
                )
              }}</span>
            </b-form-checkbox>
            <b-form-checkbox
              v-if="isAdultnewTeamShow == 1 || isAdultnewTeamShow == 3"
              v-model="form.isAgree"
              :disabled="is_perview"
            >
              <span class="lbl">{{ $lang("TEXT_ACCEPT_SELF_6") }}</span>
            </b-form-checkbox>
            <template v-if="isAdultnewTeamShow == 2 || isAdultnewTeamShow == 3">
              <p>
                <span
                  >{{ $lang("ATTENTION_FOUR_FIRST_REQUIRED") }}(<a
                    :href="url"
                    target="_blank"
                    >{{ $lang("TITLE_HEALTH_DOWN_URL") }}</a
                  >){{ $lang("ATTENTION_FOUR_LAST") }}</span
                >
              </p>

              <div class="upload-check" :disabled="is_perview">
                <InputFile
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="form.healthFile"
                  :word="$lang('BTN_UPLOAD_FILE')"
                  :disabled="is_perview"
                />
                <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
              </div>
            </template>
          </div>
        </div>
        <b-form-group :label="$lang('FIELD_CHILD_GROUP_NAME')">
          <b-form-input
            type="text"
            v-model="form.teamName"
            v-validate="'required'"
            name="teamName"
            :class="errors.has('teamName') && 'is-invalid'"
            :disabled="is_perview"
          ></b-form-input>
          <b-form-invalid-feedback :state="errors.has('teamName')">
            {{ errors.first("teamName") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <template v-for="(item, index) in form.teamMembers">
          <div :key="item.key">
            <p class="text-left" v-if="index == 0">{{ $lang("隊長") }}</p>
            <p class="text-left" v-if="index > 0">{{ $lang("隊員") }}</p>
            <summer-form
              :isIndividual="true"
              :requiredType="requiredType"
              :value.sync="item"
              :rules="rules"
              @isAdultNewTeam="isAdultNewTeam"
              class="dashed"
              ref="form-item"
              :disabled="is_perview"
            >
            </summer-form>
          </div>
        </template>
        <div class="form-footer">
          <div>
            <template v-if="!is_perview">
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="save"
                :disabled="isDisable"
              >
                {{ $lang("TEXT_SAVE") }}
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="submitForm"
                :disabled="isDisable"
              >
                {{ $lang("提交") }}
              </button>
            </template>
            <p>
              {{ $lang("TITLE_FORM_TIP") }}
            </p>
          </div>
        </div>
      </b-form>

      <b-form
        ref="form2"
        @submit="onSubmit2"
        v-show="is_group === 'individual' || is_group === 'entertainment'"
      >
        <div class="form-header">
          <div class="checkbox-group">
            <p class="checkbox-attention-text">
              <span>{{ $lang("TEXT_ATTENTION_CHECKBOX") }}</span>
            </p>
            <b-form-checkbox v-model="form2.isAgree3" :disabled="is_perview">
              <span style="padding-top: 2px" class="lbl">{{
                $lang(
                  "我已知悉於比賽當天必須完成接種兩劑新冠疫苗滿14天或持有效的核酸檢測陰性報告"
                )
              }}</span>
            </b-form-checkbox>
            <b-form-checkbox
              v-if="isAdultnew"
              v-model="form2.isAgree"
              :disabled="is_perview"
            >
              <span class="lbl">{{ $lang("TEXT_ACCEPT_SELF_6") }}</span>
            </b-form-checkbox>
            <template v-else>
              <p>
                <span
                  >{{ $lang("ATTENTION_FOUR_FIRST_OBSTACLE") }}(<a
                    :href="url"
                    target="_blank"
                    >{{ $lang("TITLE_HEALTH_DOWN_URL") }}</a
                  >){{ $lang("ATTENTION_FOUR_LAST") }}</span
                >
              </p>

              <div class="upload-check" :disabled="is_perview">
                <InputFile
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="form2.healthFile"
                  :word="$lang('BTN_UPLOAD_FILE')"
                  :disabled="is_perview"
                />
                <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
              </div>
            </template>
          </div>
        </div>
        <summer-form
          :isIndividual="true"
          :requiredType="requiredType"
          :value.sync="form2.teamMembers[0]"
          :rules="is_group === 'entertainment' ? rules_entertainment : rules"
          ref="form2-item"
          class="dashed"
          :disabled="is_perview"
        ></summer-form>
        <div class="form-footer">
          <div>
            <template v-if="!is_perview">
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="save"
                :disabled="isDisable"
              >
                {{ $lang("TEXT_SAVE") }}
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="submitForm"
                :disabled="isDisable"
              >
                {{ $lang("提交") }}
              </button>
            </template>
            <p>
              {{ $lang("TITLE_FORM_TIP") }}
            </p>
          </div>
        </div>
      </b-form>
    </div>
    <div class="spinner" v-show="loading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import SummerForm from "@/components/SummerForm";
import InputFile from "@/components/InputFile";
import { ValidationObserver } from "vee-validate";
import utils from "@/helper/utils";

export default {
  props: {
    mode: {
      type: String,
      default: "new",
    },
  },
  components: {
    InputFile,
    SummerForm,
    ValidationObserver,
  },
  data() {
    return {
      isAdultnewTeam: false,
      isAdultnewTeamShow:1,
      loading: false,
      index: 4,
      isAdultnew: false,
      requiredType: false,
      status: "",
      // selected: '',
      isType: "",
      isDisable: false,
      rules: {
        birth: {
          obstacle_conforming_age: [1925, 2005],
        },
      },
      rules_entertainment: {
        birth: {
          obstacle_entertainment_age: [1925, 2008],
        },
      },
      form: {
        id: null,
        healthFile: "",
        isAgree: null,
        isAgree3: null,
        gameType: "team",
        teamName: null,
        isChallenge: true,
        teamMembers: [
          {
            phone: "",
            isTeamCaptain: true,
            lastName: "",
            firstName: "",
            bornAt: "",
            idNumber: "",
            gender: "M",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
          {
            phone: "",
            lastName: "",
            firstName: "",
            bornAt: "",
            idNumber: "",
            gender: "M",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
          {
            phone: "",
            lastName: "",
            firstName: "",
            bornAt: "",
            idNumber: "",
            gender: "",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
        ],
      },
      form2: {
        id: null,
        gameType: "individual",
        healthFile: null,
        isAgree: null,
        isAgree3: null,
        // isAgree: true,
        isChallenge: null,
        teamMembers: [
          {
            isTeamCaptain: true,
            phone: null,
            lastName: null,
            firstName: null,
            bornAt: "",
            idNumber: null,
            gender: "M",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
        ],
      },
    };
  },
  watch: {
    isAdultnewTeam(n) {
      // console.log(typeof n,typeof n=='string',n);
      var a = this.form.teamMembers.every((el) => el.bornAt != "");
      var d = this.form.teamMembers.every((el) => typeof el.bornAt == "object");
      if (a && d) {
        var b = this.form.teamMembers.every(
          (el) => el.bornAt.getFullYear() <= 2003
        );
        var c = this.form.teamMembers.every(
          (el) => el.bornAt.getFullYear() > 2003
        );
        if (b) {
          //全是成人
          this.isAdultnewTeamShow = 1;
        } else if (c) {
          //全是未成年
          this.isAdultnewTeamShow = 2;
        } else {
          //都有
          this.isAdultnewTeamShow = 3;
        }
      } else {
         var a = this.form.teamMembers.every((el) => el.bornAt != "");
     if(a){
          let ad = 0;
        this.form.teamMembers.map((el) => {
          if (typeof el.bornAt == "string") {
            if (el.bornAt != "") {
              console.log(el.bornAt, "dates");
              if (Number(el.bornAt.substring(0, 4)) <= 2003) {
                ad = ad + 1;
                console.log(1);
              } else {
                ad = ad - 1;
              }
            }
          } else {
            if (el.bornAt != "") {
              console.log(el.bornAt.getFullYear(), "date");
              if (el.bornAt.getFullYear() <= 2003) {
                ad = ad + 1;
              } else {
                ad = ad - 1;
              }
            }
          }
        });
        if (ad == 0) {
          this.isAdultnewTeamShow = 2;
        } else if (ad == 3) {
          this.isAdultnewTeamShow = 1;
        } else {
          this.isAdultnewTeamShow = 3;
        }
     }
      }
    },
    isAdultnew(n) {
      this.form2.healthFile = null;
      this.form2.isAgree = null;
    },
  },
  methods: {
    getGrouping(flag) {
      if (flag) {
        this.ispersion = false;
      } else {
        this.ispersion = true;
      }
    },
    getGroupings(flag) {
      if (flag) {
        this.ispersion = false;
      } else {
        this.ispersion = true;
      }
    },
    isAdultNewTeam(flag) {
      this.isAdultnewTeam = flag;
    },
    isAdultNew(flag) {
      if (flag) {
        this.isAdultnew = true;
      } else {
        this.isAdultnew = false;
      }
    },
    save() {
      this.requiredType = false;
      this.status = "draft";
    },
    submitForm() {
      this.requiredType = true;
      this.status = "approval";
    },
    async onSubmit(evt) {
      evt.preventDefault();
      var form = {
        ...this.form,
        status: this.status,
        teamMembers: this.uploadMembers(this.form.teamMembers),
      };
      if (
        (this.status === "approval" && form.teamName === null) ||
        form.teamName === ""
      ) {
        this.$validator.validate("teamName").then((validate) => {
          this.errorScoll();
        });
        return false;
      }
      if (this.status === "draft") {
        this.recordUpdate(form);
        this.errorScoll();
      } else {
        let hasfemale = false;
        let teamMembers = form.teamMembers;
        teamMembers.forEach((item, index) => {
          const gender = item.gender;
          if (gender === "F") {
            hasfemale = true;
          }
        });
        if (!hasfemale) {
          this.notification.warning(this.$lang("至少有一名為女性"));
          return false;
        }
        // var noChild = this.noChild(form);
        var promise_list = await this.$refs["form-item"].map((item) =>
          item.onSubmit()
        );
        // var result = promise_list.every(item => item);
        // await this.$validator.validateAll("form1");
        // this.errorScoll();
        this.$validator.validateAll("form1").then((validate) => {
          Promise.all(promise_list).then((list) => {
            var result = list.every((item) => item);
            this.errorScoll();

            // 不用判斷child
            if (
              this.isAdultnewTeamShow == 3
                ? form.isAgree && form.healthFile
                : (form.isAgree || form.healthFile) && form.isAgree3
            ) {
              if (result) {
                this.recordUpdate(form);
                this.errorScoll();
              }
            } else {
              this.notification.warning(this.$lang("TEXT_WARNING_2"));
            }
            // if (form.isAgree && form.healthFile) {
            //   if (result) {
            //     this.recordUpdate(form);
            //     this.errorScoll();
            //   }
            // } else {
            //   this.notification.warning(this.$lang("TEXT_WARNING_1"));
            // }
          });
        });
      }
    },
    async onSubmit2(evt) {
      evt.preventDefault();
      if (this.is_group === "entertainment") {
        this.form2.isChallenge = false;
      } else {
        this.form2.isChallenge = true;
      }
      var form2 = {
        ...this.form2,
        status: this.status,
        teamMembers: this.form2.teamMembers.map((item, index) => {
          delete item["key"];
          delete item["index"];
          if (item.firstVaccination) {
            item.firstVaccination =
              this.$changeTime(item.firstVaccination) || "";
          }
          if (item.secondVaccination) {
            item.secondVaccination =
              this.$changeTime(item.secondVaccination) || "";
          }

          item.bornAt = this.$changeTime(item.bornAt) || "";
          return item;
        }),
      };
      // if (this.form2.isChild == true) {
      //   form2.mixedChallenge = this.form2.teenager
      //   form2.individual = false
      // } else {
      //   form2.mixedChallenge = this.form2.public
      // }
      if (this.status === "draft") {
        this.recordUpdate2(form2);
        this.errorScoll();
      } else {
        // var noChild = this.noChild(form2);
        // var bornAt = form2.bornAt;
        // var year = utils.getYear(bornAt);
        // var noChild = !(year > 2001 && year <= 2004);
        var bornAt = form2.teamMembers[0].bornAt;
        var year = utils.getYear(bornAt);
        var isAdult = year <= 2002;
        let result = await this.$refs["form2-item"].onSubmit();
        this.$validator.validateAll("form2").then((validate) => {
          if ((form2.isAgree || form2.healthFile) && form2.isAgree3) {
            if (result) {
              this.recordUpdate2(form2);
              this.errorScoll();
            }
          } else {
            this.notification.warning(this.$lang("TEXT_WARNING_2"));
          }
          // if(form2.isAgree) {
          //   if(form2.healthFile) {
          //     this.recordUpdate2(form2);
          //     this.errorScoll();
          //   } else {
          //     this.notification.warning(this.$lang("TEXT_WARNING_1"));
          //   }
          // }else {
          //   this.notification.warning(this.$lang("TEXT_WARNING_3"));
          // }

          // 未成年人必須作出聲明和上傳聲明書，成年人作出聲明或上傳聲明書
          // if (isAdult) {
          //   if (form2.isAgree || form2.healthFile) {
          //     if (result) {
          //       this.recordUpdate2(form2);
          //       this.errorScoll();
          //     }
          //   } else {
          //     this.notification.warning(this.$lang("TEXT_WARNING_2"));
          //   }
          // } else {
          //   if (form2.isAgree) {
          //     if (form2.healthFile) {
          //       if (result) {
          //         this.recordUpdate2(form2);
          //         this.errorScoll();
          //       }
          //     } else {
          //       this.notification.warning(this.$lang("TEXT_WARNING_1"))
          //     }
          //   } else {
          //     this.notification.warning(this.$lang("TEXT_WARNING_3"));
          //   }
          // }
        });
      }
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    noChild(form) {
      let noChild = true;
      let teamMembers = form.teamMembers;
      teamMembers.forEach((item, index) => {
        const bornAt = item.bornAt;
        const year = utils.getYear(bornAt);
        if (year > 2001 && year <= 2004) {
          noChild = false;
        }
      });
      return noChild;
    },
    handleRemove(item) {
      if (this.form.teamMembers.length <= 4) {
        return;
      }
      var index = this.form.teamMembers.indexOf(item);
      if (index !== -1) {
        this.form.teamMembers.splice(index, 1);
      }
    },
    handleAdd() {
      this.index++;
      this.form.teamMembers.push({
        index: this.index,
        lastName: null,
        firstName: null,
        gender: null,
        bornAt: "",
        idType: 1,
        idNumber: null,
      });
    },
    uploadMembers(list) {
      return list.map((item, index) => {
        delete item["key"];
        delete item["index"];
        item.bornAt = this.$changeTime(item.bornAt) || "";
        if (item.firstVaccination) {
          item.firstVaccination = this.$changeTime(item.firstVaccination) || "";
        }
        if (item.secondVaccination) {
          item.secondVaccination =
            this.$changeTime(item.secondVaccination) || "";
        }
        return item;
      });
    },
    recordUpdate(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "obstacle-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              }
              var errs = err.data.teamMembers;
              var that = this;
              Object.keys(errs).forEach(function (key) {
                that.notification.error(that.$lang(errs[key].message));
              });
            }
          })
          .finally(() => {
            this.isDisable = false;
            this.errorScoll();
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "obstacle-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              }
              var teamMembers = err.data.teamMembers;
              var that = this;
              Object.keys(teamMembers).forEach(function (key) {
                that.$refs["form-item"][key].validateErrors(
                  teamMembers[key].path,
                  that.$lang(teamMembers[key].message)
                );
                that.notification.error(that.$lang(teamMembers[key].message));
              });
              // var errs = err.data.teamMembers;
              // var that = this;
              // Object.keys(errs).forEach(function (key) {
              //     that.notification.error(that.$lang(errs[key].message));
              // });
            }
          })
          .finally(() => {
            this.isDisable = false;
            this.errorScoll();
          });
      }
    },
    recordUpdate2(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "obstacle-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers) {
              if (err.data.teamMembers instanceof Array) {
                err.data.teamMembers.forEach((item, index) => {
                  this.$refs["form2-item"].validateErrors(
                    item.path,
                    this.$lang(item.message)
                  );
                  this.notification.error(this.$lang(item.message));
                });
              } else {
                this.notification.error(this.$lang(err.message));
              }
            } else {
              this.notification.error(this.$lang(err.message));
            }
          })
          .finally(() => {
            this.isDisable = false;
            this.errorScoll();
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            // } else {
            //     this.notification.success(this.$lang("新增成功"));
            // }
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "obstacle-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form2-item"].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              this.notification.error(this.$lang(err.message));
            }
          })
          .finally(() => {
            this.isDisable = false;
            this.errorScoll();
          });
      }
    },
    async recordPro(form) {
      // 防止連續點擊重複提交
      this.isDisable = true;
      // setTimeout(() => {
      //   this.isDisable = false; //点击一次时隔两秒后才能再次点击
      // }, 2000);
      return new Promise((resolve, reject) => {
        $apis.obstacle
          .recordUpdate(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // save
    async saveForm(form) {
      // 防止連續點擊重複提交
      this.isDisable = true;
      // setTimeout(() => {
      //   this.isDisable = false; //点击一次时隔两秒后才能再次点击
      // }, 2000);
      return new Promise((resolve, reject) => {
        $apis.obstacle
          .save(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async recordDetail(id) {
      if (this.mode === "perview") {
        this.loading = true;
        let resp = await $apis.obstacle.recordDetail({
          id,
        });
        this.loading = false;
        var gameType = resp.data.gameType;
        var isChallenge = resp.data.isChallenge;
        if (gameType == "individual") {
          this.form2 = resp.data;
          if (isChallenge === true) {
            this.isType = "individual";
          } else {
            this.isType = "entertainment";
          }
        } else {
          this.form = resp.data;
          this.isType = "team";
        }
      } else {
        this.loading = true;
        let resp = await $apis.obstacle.load({
          id,
        });
        this.loading = false;
        var gameType = resp.data.gameType;
        var isChallenge = resp.data.isChallenge;
        if (gameType == "individual") {
          this.form2 = resp.data;
          if (isChallenge === true) {
            this.isType = "individual";
          } else {
            this.isType = "entertainment";
          }
        } else {
          this.form = resp.data;
          this.isType = "team";
        }
      }
    },
    getUserInfo() {
      this.loading = true;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          var data = resp.data;
          // if (this.is_group === 'team') {
          (this.form.teamMembers[0].lastName =
            data.lastNameZh || data.lastNamePt),
            (this.form.teamMembers[0].firstName =
              data.firstNameZh || data.firstNamePt),
            (this.form.teamMembers[0].bornAt = data.bornAt);
          this.form.teamMembers[0].gender = data.gender;
          this.form.teamMembers[0].idType = data.idType;
          this.form.teamMembers[0].idNumber = data.idNumber;
          this.form.teamMembers[0].phone = "";
          // } else {
          (this.form2.teamMembers[0].lastName =
            data.lastNameZh || data.lastNamePt),
            (this.form2.teamMembers[0].firstName =
              data.firstNameZh || data.firstNamePt),
            (this.form2.teamMembers[0].bornAt = data.bornAt);
          this.form2.teamMembers[0].gender = data.gender;
          this.form2.teamMembers[0].idType = data.idType;
          this.form2.teamMembers[0].idNumber = data.idNumber;
          this.form2.teamMembers[0].phone = "";
          // }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectedChange() {
      // var id = this.$route.params.slug;
      // if (id) {
      //   let resp = await $apis.obstacle.load({ id });
      //   if (resp.code === 0) {
      //     if(resp.data.gameType === 'team') {
      //       this.form2 = resp.data
      //     } else {
      //       this.form = resp.data
      //     }
      //   }
      // } else {
      //   this.getUserInfo()
      // }
      this.$validator.reset();
    },
    // getGrouping(flag) {
    //   this.form2.isChild = flag;
    //   if (this.form2.isChild == true) {
    //     this.form2.individual = false;
    //   }
    // },
    // 處理perview時混合體能挑戰賽的顯示與隱藏
    // handelShow() {
    //   if (this.form2.isChild == false) {
    //     this.form2.public = this.form2.mixedChallenge
    //   } else {
    //     this.form2.teenager = this.form2.mixedChallenge
    //   }
    // }
  },
  computed: {
    // 判斷個人/團隊報名
    is_group() {
      // return this.$route.query.type || this.isType
      return this.isType;
    },
    disabled() {
      return this.mode === "perview" || this.mode === "edit";
    },
    is_full() {
      return this.$route.query.number < 3;
    },
    is_perview() {
      return this.mode === "perview";
    },
    is_edit() {
      return this.mode === "edit";
    },
    is_new() {
      return this.mode === "new";
    },
    downPdf() {
      return this.$store.getters["base/obstacleHealthFileExample"];
    },
    link() {
      return this.$store.getters["base/baseUrl"];
    },
    url() {
      return this.link + this.downPdf;
    },
  },
  created() {
    if (this.$route.query.type) {
      this.isType = this.$route.query.type;
    }
    var id = this.$route.params.slug;
    var isNew = this.is_new;
    this.form.id = id;
    this.form2.id = id;
    id && this.recordDetail(id);
    isNew && this.getUserInfo();
  },
};
</script>